import { forwardRef, useMemo } from "react";
import { FloorPlanPanelWrapper } from "components/SmartSurveyor/ReviewPage/FloorPlanPanelWrapper";
import type { FloorPlanPanelHandlers } from "components/SmartSurveyor/ReviewPage/FloorPlanPanelNew/types";
import { getPreviewUrlKey } from "components/SmartSurveyor/shared/getPreviewUrlKey";
import type { DiffViewerProps } from "./types";

const RENDERED_PAGE_INDEX = 0;
const NOOP = () => {};

export const DiffViewer = forwardRef<FloorPlanPanelHandlers, DiffViewerProps>(
  (
    {
      afterPlan,
      afterPlanName,
      detectedObjects,
      circuitPaths,
      selectedObject,
      onSelectObjectId,
      navigationObjects,
      isObjectNavigationVisible,
      onAfterNavigate,
    },
    ref,
  ) => {
    const plan = useMemo(
      () => ({
        previewUrl: afterPlan.planImage,
        pdfUrl: afterPlan.pdfUrl,
        pageNumber: RENDERED_PAGE_INDEX + 1,
        name: afterPlanName,
        imageWidthPx: afterPlan.imageWidthPx,
        imageHeightPx: afterPlan.imageHeightPx,
      }),
      [afterPlan, afterPlanName],
    );

    const imageScaleFactor =
      afterPlan.pageScaleFactors.get(RENDERED_PAGE_INDEX) ?? 1;
    const rotation =
      afterPlan.rotationByPageIndex.get(RENDERED_PAGE_INDEX) ?? 0;

    return (
      <FloorPlanPanelWrapper
        ref={ref}
        key={getPreviewUrlKey(plan.previewUrl)}
        plan={plan}
        viewerMode="image"
        onViewerModeChange={NOOP}
        hideViewerModeToggle
        imageScaleFactor={imageScaleFactor}
        rotation={rotation}
        detectedObjects={detectedObjects}
        circuitPaths={circuitPaths}
        selectedObject={selectedObject}
        setSelectedObject={onSelectObjectId}
        navigationObjects={navigationObjects}
        showObjectNavigation={isObjectNavigationVisible}
        onAfterNavigate={onAfterNavigate}
        zoomToFitOnImageLoad="always"
        isAutoZoomEnabled={false}
      />
    );
  },
);
